class RoomBookingUrl {
    constructor(el) {
        if (!el) return

        try {
            const url = new URL(el.href)
            const today = new Date()

            url.searchParams.set("in", this.formatDate(today))
            url.searchParams.set("out", this.formatDate(today, 1))

            el.href = url.href
        } catch (error) {
            console.error("Failed to update booking URL:", error)
        }
    }

    formatDate = (date, daysToAdd = 0) => {
        const newDate = new Date(date)
        newDate.setDate(newDate.getDate() + daysToAdd)
        newDate.setHours(12)
        return newDate.toISOString().split('T')[0]
    }
}

export default RoomBookingUrl